<template lang="pug">
.subscribe-modal
  edit-member-modal(v-if="openEditMemberDialog" :open.sync="openEditMemberDialog" :company="company" :count="totalAllowedMember")
  edit-form-modal(v-if="openEditFormDialog" :open.sync="openEditFormDialog" :company="company" :count="totalAllowedForm")
  y-dialog(v-model="dialog" max-width="600px" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4
        .h6.textColor--text {{ $t('subscription') }}
      v-card-text.px-4
        y-stepper.mb-8(v-if="step < 4" :currentStep="step" :steps="steps")
        v-window(v-model="step" touchless)

          v-window-item(:value="0")
            //- =========================================================================================================
            //-  1. Choose your plan
            //- =========================================================================================================
            v-layout.pa-6(v-if="isFetchingPlanGroup")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contracts(v-else)
              .s2.mt-4 {{ $t('step_0.current_account') }}
              v-row.mt-2(align="center")
                v-col.py-0
                  .p2(:class="!selectedPlan || (selectedPlan && isValidMemberCount) ? 'primary400--text' : 'danger--text' ") {{ company.active_member_count }} {{ $t('step_0.members') }}
                v-col.shrink.py-0
                  v-btn(v-if="selectedPlan && !isValidMemberCount" @click="openEditMemberDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                    .button-AA-tiny.danger500--text {{ $t('step_0.manage_button') }}
              v-row.mt-3(align="center")
                v-col.py-0
                  .p2(:class="!selectedPlan || (selectedPlan && isValidFormCount) ? 'primary400--text' : 'danger--text' ") {{ company.published_form_count }} {{ $t('step_0.forms') }}
                v-col.shrink.py-0
                  v-btn(v-if="selectedPlan && !isValidFormCount" @click="openEditFormDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                    .button-AA-tiny.danger500--text {{ $t('step_0.manage_button') }}

              template(v-if="subscribedAddons.forms || subscribedAddons.members")
                .s2.mt-4 {{ $t('step_0.active_addons') }}
                template(v-if="subscribedAddons.forms")
                  div.p2.success600--text(v-for="(form, index) in subscribedAddons.forms" :key="'form-'+index") {{ $tc('step_0.form_addons', form.count, { count: form.count, date: $options.filters.displayDate(form.activeUntil) }) }}
                template(v-if="subscribedAddons.members")
                  div.p2.success600--text(v-for="(member, index) in subscribedAddons.members" :key="'member-'+index") {{ $tc('step_0.member_addons', member.count, { count: member.count, date: $options.filters.displayDate(member.activeUntil) }) }}

              .main-container.my-6.mx-n4
                v-tabs(v-model="selectedCommitmentType" color="textColorAccent" :height="40" grow)
                  v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 0? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }") {{ $t('step_0.yearly_contract') }}
                  v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 1? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }") {{ $t('step_0.monthly_contract') }}
                div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

              v-card.px-4.mb-4.pb-1(v-if="plan.price && plan.price[form.commitment] && plan.price[form.commitment][$currency.code] && plan.value!== 4" outlined v-for="(plan, index) in plans" :ripple="false" :key="plan.value" :style="plan.selected ? 'border:2px solid var(--v-textColorAccent)' : 'border:2px solid var(--v-basic300)'" :color="currentPlan(plan) ? $vuetify.theme.themes[$theme].dangerT08: $vuetify.theme.themes[$theme].basic600T08")
                div.pt-2(@click="selectPlan(plan)")
                  v-row
                    v-col
                      v-layout
                        .h5.textColor--text {{ plan.name }}
                        v-avatar.my-auto.ml-2(v-if="plan.selected" :color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                          eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16" style="margin-top:2px;")
                      div.danger500--text(v-if="currentPlan(plan)") ({{ $t('step_0.current_plan') }})
                    v-col
                      .h6.textColorHint--text.text-decoration-line-through.text-right(v-if="plan.slash_price[form.commitment] && plan.slash_price[form.commitment][$currency.code]") {{ plan.slash_price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
                      .h4.textColor--text.text-right(v-if="plan.price[form.commitment]") {{ plan.price[form.commitment][$currency.code] | displayNumberPrice($currency)  }}
                  v-row.mb-3(no-gutters)
                    v-col
                      .p1.primary500--text {{ plan.detail.form }}
                      .p1.primary500--text {{ plan.detail.member }}
                    v-col
                      .p2.primary400--text.text-right {{ $currency.symbol }} per {{ form.commitment === 'yearly' ? 'year' : 'month' }}
                      .p2.primary400--text.text-right(v-if="form.commitment === 'monthly' && plan.value !== 4")

                  div.mb-3(v-if="plan.value === 3 ")
                    .p1.success600--text + {{ $t('step_0.follow_up_system') }}
                    .p1.success600--text + {{ $t('step_0.agent_commission_system') }}
                    .p1.success600--text + {{ $t('step_0.product_bundle_offer') }}

              .s1.mb-2 {{ $t('step_0.subscribed_addons') }}
              v-card.pa-2.mb-4(v-if="selectedPlan" outlined style="border:1px solid var(--v-basic300); border-radius:0")
                v-list-item.px-0.my-n2
                  v-list-item-content
                    v-list-item-title.font-weight-bold {{ $t('step_0.form') }}
                    v-list-item-subtitle(v-if="form.commitment ==='monthly'") + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].form[$currency.code])}` }} {{ $t('step_0.each_month') }}
                    v-list-item-subtitle(v-else) + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].form[$currency.code])}` }} {{ $t('step_0.each_year') }}
                  v-list-item-action
                    v-layout
                      v-btn.my-auto(icon small @click="formAddOnCount--" :disabled="formAddOnCount < 1")
                        v-icon(color="primary") mdi-minus-circle
                      span.my-auto.text-center.colbox {{ formAddOnCount }}
                      v-btn.my-auto(icon small @click="formAddOnCount++")
                        v-icon(color="primary") mdi-plus-circle
                v-list-item.px-0.my-n2
                  v-list-item-content
                    v-list-item-title.font-weight-bold {{ $t('step_0.salesperson') }}
                    v-list-item-subtitle(v-if="form.commitment ==='monthly'") + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].member[$currency.code])}` }} {{ $t('step_0.each_month') }}
                    v-list-item-subtitle(v-else) + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].member[$currency.code])}` }} {{ $t('step_0.each_year') }}
                  v-list-item-action
                    v-layout
                      v-btn.my-auto(icon small @click="memberAddOnCount--" :disabled="memberAddOnCount < 1")
                        v-icon(color="primary") mdi-minus-circle
                      span.my-auto.text-center.colbox {{ memberAddOnCount }}
                      v-btn.my-auto(icon small @click="memberAddOnCount++")
                        v-icon(color="primary") mdi-plus-circle

          v-window-item(:value="1")
            //- =========================================================================================================
            //-  2. Select payment method
            //- =========================================================================================================

            .h5.textColor--text.text-center {{ $t('step_1.select_payment_method') }}
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text {{ $t('step_1.card') }}
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                v-layout(:style="(form.commitment === 'monthly' || form.billing_cycle === 'monthly') ? 'cursor: default' : 'cursor: pointer'" @click="(form.commitment === 'monthly' || form.billing_cycle === 'monthly') ? '' : selectedPaymentMethod = 'fpx'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    BuildingBankIcon.ma-auto(size="24" :style="form.commitment === 'yearly' ? 'color: var(--v-basic700)' : 'color: var(--v-basic500)'")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1(:class="form.commitment === 'yearly' ? 'basic800--text' : 'basic500--text' ") {{ $t('step_1.online') }}
                        .c1.basic500--text(v-if="form.commitment === 'monthly'") {{ $t('step_1.yearly_contract') }}
                        .c1.basic500--text(v-if="form.commitment === 'yearly' && form.billing_cycle === 'monthly'") {{ $t('step_1.annual_billing') }}
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx' && company.currency.currency_code === 'MYR'" )
                div.subtitle.mb-3 {{ $t('step_1.choose_bank') }}
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")

          v-window-item.text-center(:value="2")
            //- =========================================================================================================
            //-  3. Confirm your subscription
            //- =========================================================================================================
            v-layout.pa-6(v-if="isFetchingQuotation")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            template(v-else-if="quotation")
              template(v-if="hasPendingBills")
                .h3.mt-12.danger500--text {{ $t('step_2.pending_payment') }}
                .h6.mt-6.textColor--text {{ $tc('step_2.you_have', quotation.pending_bills.length, { count: quotation.pending_bills.length }) }} {{ $t('step_2.please_take') }}
                v-btn.mt-4(color="danger500" dark @click="clickPayBill" depressed height=32 )
                  .button-AA-medium.basic100--text {{ $t('step_2.pay_now') }}
              template(v-else-if="quotation.void")
                .h6.mt-12.danger500--text {{ $t('no_change_subscription') }}
              template(v-else)
                .h5.textColor--text.text-center {{ $t('step_2.confirm_subscribe') }}
                .h3.mt-6.textColor--text {{ selectedPlan.name }} {{ $t('step_2.plan') }}
                .extra
                  .side(v-if="formAddOnCount || memberAddOnCount")
                    .s1.primary500--text(v-if="formAddOnCount") + {{ formAddOnCount }} {{ $tc('step_2.extra_form', formAddOnCount) }}
                    .s1.primary500--text(v-if="memberAddOnCount") + {{ memberAddOnCount }} {{ $tc('step_2.extra_member', memberAddOnCount) }}
                .h1.text-center.my-8 {{ quotation.total_amount | displayPrice($currency) }}
                .s1.primary500--text {{ $t('step_2.next_billing_amount', { amount: $options.filters.displayPrice(quotation.next_bill_amount, $currency) }) }}
                .s1.primary500--text {{ $t('step_2.next_billing_date', { date: $options.filters.displayDate(quotation.end_date) }) }}

          v-window-item(:value="3")
            //- =========================================================================================================
            //-  4. Thank you
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center {{ $t('step_3.subscribe_successful') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_3.thanks') }}
              .p1.primary400--text.mt-4 {{ $t('step_3.thanks_2') }}
              v-btn.mt-4(color="info500" dark @click="closeDialog" depressed height=32 )
                .button-AA-medium.basic100--text {{ $t('step_3.finish_button') }}

          v-window-item(:value="4")
            //- =========================================================================================================
            //-  4. Payment failed
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center {{ $t('step_4.payment_failed') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_4.try_again') }}
              v-btn.mt-4(color="info500" dark @click="retryPayment" depressed height=32 )
                .button-AA-medium.basic100--text {{ $t('step_4.retry_button') }}

      v-divider.basic300(v-if="step == 0")
      v-card-actions.basic200.px-4(v-if="step == 0 && selectedPlan")
        v-col.pa-0
          .s2.primary400--text {{ $t('card_actions.selected_plan') }}
          v-layout
            .p2.textColor--text {{ selectedPlan.name }} ({{ form.commitment }} {{ $t('card_actions.contract') }})
            v-spacer
            .p2.textColor--text(v-if="selectedPlan.price[form.commitment]") {{ $currency.symbol }} {{ selectedPlan.price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
          v-layout(v-if="formAddOnCount")
            .p2.textColor--text + {{ formAddOnCount }} {{ $t('card_actions.forms', { text: form.commitment }) }}
            v-spacer
            .p2.textColor--text {{ $currency.symbol }} {{ $options.filters.displayNumberPrice(formAddOnCount * selectedPlan.addon_price[form.commitment].form[$currency.code]) }}
          v-layout(v-if="memberAddOnCount")
            .p2.textColor--text + {{ memberAddOnCount }} {{ $t('card_actions.salespersons', { text: form.commitment }) }}
            v-spacer
            .p2.textColor--text {{ $currency.symbol }} {{ $options.filters.displayNumberPrice(memberAddOnCount * selectedPlan.addon_price[form.commitment].member[$currency.code]) }}
          .p2.danger500--text(v-if="!isValidMemberCount || !isValidFormCount") {{ $t('card_actions.manage_account') }}
      v-divider.basic400(v-if="step == 0")

      v-card-actions.pr-4(v-if="authMember.id === company.primary_owner" :class="step == 0 ? 'basic200' : ''")
        template(v-if="step < 3")
          v-spacer
          v-btn(v-if="step === 0" color='white' text @click="dialog = false")
            .button-Aa-medium.primary400--text {{ $t('card_actions.cancel') }}
          v-btn(v-else color='white' text @click="step--")
            .button-Aa-medium.primary400--text {{ $t('card_actions.back') }}
          v-btn(v-if="step === 0" color="info500" @click="nextStep" depressed height=32 :disabled="!selectedPlan")
            .button-AA-medium.basic100--text {{ $t('card_actions.next') }}
          v-btn(v-else-if="step == 1" color="info500" @click="nextStep" depressed height=32 :disabled="((company.currency.currency_code === 'MYR' && !fpxBankCode) || selectedPaymentMethod !== 'fpx') && !form.card")
            .button-AA-medium.basic100--text {{ $t('card_actions.next') }}
          v-btn(v-else color="info500" @click="nextStep" depressed height=32 :loading="isLoading" :dark="!disableProceedPayment" :disabled="disableProceedPayment")
            .button-AA-medium.basic100--text {{ step === 2 ? $t('card_actions.confirm_pay') : $t('card_actions.next')  }}
      v-card-actions(v-else)
        v-spacer
        v-btn(v-if="company.status === 'Trial'" color='white' text @click="dialog = false")
          .button-Aa-medium.primary400--text {{ $t('card_actions.close') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import EditMemberModal from './EditMemberModal'
import EditFormModal from './EditFormModal'
import Cookies from 'js-cookie'

export default {
  name: "EditSubscriptionModal",
  components: { CardList, EditMemberModal, EditFormModal, FPXPicker },
  props: ['open', 'company', 'paymentCallback'],
  data: (v) => ({
    openEditMemberDialog: false,
    openEditFormDialog: false,
    selectedCommitmentType: 0,
    selected: true,
    step: 0,
    steps: [
      { title: 'Select plan', hidden: false},
      { title: 'Payment', hidden: false},
      { title: 'Confirmation', hidden: false},
      { title: 'Subscription Successful!', hidden: true},
      { title: 'Payment Unsuccessful', hidden: true}
    ],
    plans: [
      { name: 'Free', value: 4, detail: { form: '1 form', member: '1 salesperson' }, form_count: 1, member_count: 1, max: { member: null, form: null }, selected: false, plan: 'YZ_FREE_V2_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '2.9' },
      { name: 'Start', value: 2, detail: { form: '3 forms', member: '3 salesperson' }, form_count: 3, member_count: 3, max: { member: null, form: null }, selected: false, plan: 'YZ_START_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '0' },
      { name: 'Growth', value: 3, detail: { form: '10 forms', member: '10 salesperson' }, form_count: 10, member_count: 10, max: { member: null, form: null }, selected: false, plan: 'YZ_GROWTH_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '0' }
    ],
    selectedPlan: null,
    commitments: [
      { text: 'Yearly contract', value: 'yearly' },
      { text: 'Monthly contract', value: 'monthly' }
    ],
    form: {
      company: v.company.id,
      plan: null,
      contract: null,
      commitment: 'monthly',
      billing_cycle: 'yearly',
      card: null
    },
    isFetchingPlanGroup: false,
    isFetchingQuotation: false,
    planGroup: null,
    formAddOnCount: 0,
    memberAddOnCount: 0,
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    retryPaymentLoading: false,
    quotation: null
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaSubscription', 'followUpSubscription', 'bundleSubscription', 'resellerSubscription', 'genesData']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    totalAllowedMember () {
      if (this.selectedPlan) {
        return this.selectedPlan.member_count + this.memberAddOnCount
      }
      return 0
    },
    isValidMemberCount () {
      if (this.company.active_member_count > this.totalAllowedMember) {
        return false
      }
      return true
    },
    totalAllowedForm () {
      if (this.selectedPlan) {
        return this.selectedPlan.form_count + this.formAddOnCount
      }
      return 0
    },
    isValidFormCount () {
      if (!this.selectedPlan) {
        return false
      }
      if (this.selectedPlan.name == 'Intelligence' || this.selectedPlan.name == 'Growth' ) {
        return true
      }
      if (this.company.published_form_count > this.totalAllowedForm) {
        return false
      }
      return true
    },
    subscribedAddons () {
      let form = this.genesData.find(f => f.feature === 'YZ_FORM')
      let member = this.genesData.find(f => f.feature === 'YZ_MEMBER')
      let addons = {}
      if (form) {
        addons.forms = form.data
      }
      if (member) {
        addons.members = member.data
      }
      return addons
    },
    hasPendingBills () {
      if (this.quotation && this.quotation.pending_bills.length > 0) {
        return true
      }
      return false
    },
    disableProceedPayment () {
      if (!this.quotation) {
        return true
      }
      if (this.quotation.void) {
        return true
      }
      if (this.hasPendingBills) {
        return true
      }
      return false
    }
  },
  watch: {
    selectedCommitmentType: {
      immediate: true,
      handler (val) {
        if (val === 1 && this.selectedPaymentMethod == 'fpx') {
          this.selectedPaymentMethod = 'card'
        }
        this.setCommitment(val)
      }
    },
    'form.billing_cycle' (val) {
      if (val === 'monthly' && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchPlanGroup()
    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    fetchPlanGroup () {
      this.isFetchingPlanGroup = true
      this.$axios.get(`/subscription/plan_groups/YEZZA`)
        .then(resp => {
          this.planGroup = resp.data
          this.plans.forEach(o => {
            let plan = resp.data.plans.find(f => f.code === o.plan)
            if (plan) {
              let monthly = plan.contracts.find(f => f.billing_cycle === 'monthly')
              let yearly = plan.contracts.find(f => f.billing_cycle === 'yearly')
              let price = {
                monthly: monthly?.prices || null,
                yearly: yearly?.prices || null
              }
              let slash_price = {
                monthly: monthly?.compare_at_prices && Object.keys(monthly?.compare_at_prices).length > 0 ?  monthly.compare_at_prices : null,
                yearly: yearly?.compare_at_prices && Object.keys(yearly?.compare_at_prices).length > 0 ? yearly.compare_at_prices : null
              }
              let form_monthly = monthly?.add_ons.find(f => f.feature.code === 'YZ_FORM')
              let member_monthly = monthly?.add_ons.find(f => f.feature.code === 'YZ_MEMBER')
              let form_yearly = yearly?.add_ons.find(f => f.feature.code === 'YZ_FORM')
              let member_yearly = yearly?.add_ons.find(f => f.feature.code === 'YZ_MEMBER')
              let addon_price = {
                monthly: {
                  form: form_monthly?.prices || null,
                  member: member_monthly?.prices || null
                },
                yearly: {
                  form: form_yearly?.prices || null,
                  member: member_yearly?.prices || null
                },
              }
              this.$set(o, 'price', price)
              this.$set(o, 'slash_price', slash_price)
              this.$set(o, 'addon_price', addon_price)
            }
          })
          this.isFetchingPlanGroup = false
          this.checkCurrentPlan()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchQuotation () {
      this.isFetchingQuotation = true
      let contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}${this.form.commitment === 'monthly' ? '_MM' : this.form.billing_cycle === 'monthly' ? '_YM' : '_YY'}`)[0]
      if (!contract) {
        contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}`)[0]
      }
      if (!contract) {
        this.showMessage(['error', 'Invalid plan'])
        return
      }
      let data = {
        contract: contract.code,
        add_ons: [
          {
            feature: 'YZ_FORM',
            count: this.formAddOnCount
          },
          {
            feature: 'YZ_MEMBER',
            count: this.memberAddOnCount
          }
        ]
      }
      this.$axios.post(`/subscription/subscriptions/${this.yezzaSubscription.data.id}/quotation`, data)
        .then(resp => {
          this.quotation = resp.data
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try again or contact our support team.'])
        })
        .finally(() => {
          this.isFetchingQuotation = false
        })
    },
    setCommitment (index) {
      const selected = this.commitments[index]
      this.form.commitment = selected.value
    },
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.value === plan.value) {
          p.selected = true
          this.selectedPlan = p
        } else {
          p.selected = false
        }
      })
    },
    nextStep () {
      if (this.step === 0) {
        if (!this.isValidMemberCount) {
          this.showMessage(['error', 'Exceeded total allowed member count'])
          this.openEditMemberDialog = true
          return
        }
        if (!this.isValidFormCount) {
          this.showMessage(['error', 'Exceeded total allowed form count'])
          this.openEditFormDialog = true
          return
        }
      }

      if (this.step === this.steps.length - 1) return

      if (this.step === 1) {
        this.fetchQuotation()
      }

      if (this.step === 2) {
        this.isLoading = true
        this.$axios.post(`/subscription/subscriptions/${this.yezzaSubscription.data.id}/change`, this.quotation)
          .then(async resp => {
            if (this.quotation.contract.includes('GROWTH')) {
              await this.cancelAddonPlan()
            }
            if (this.selectedPaymentMethod === 'card') {
              this.subscribeByCard(resp.data)
            } else if (this.selectedPaymentMethod === 'fpx') {
              this.subscribeByFpx(resp.data)
            }
          })
          .catch(() => {
            this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
            this.isLoading = false
          })
      } else {
        this.step++
      }
    },
    async cancelAddonPlan () {
      if (this.followUpSubscription.value) {
        await this.$axios.post(`/subscription/subscriptions/${this.followUpSubscription.data.id}/cancel/`, {}).catch(() => {})
      }
      if (this.bundleSubscription.value) {
        await this.$axios.post(`/subscription/subscriptions/${this.bundleSubscription.data.id}/cancel/`, {}).catch(() => {})
      }
      if (this.resellerSubscription.value) {
        await this.$axios.post(`/subscription/subscriptions/${this.resellerSubscription.data.id}/cancel/`, {}).catch(() => {})
      }
    },
    subscribeByCard (data) {
      this.isLoading = true
      this.form.contracts = this.quotation.contracts
      this.form.add_ons = this.quotation.add_ons
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/bills/${data.bill}/charge_card/`, this.form)
        .then(() => {
          this.$emit('subscribed')
          this.fetchCompany()
          this.step++
          this.trackGtag()
          this.trackPixel()
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    subscribeByFpx (data) {
      this.isLoading = true
      this.form.contracts = this.quotation.contracts
      this.form.add_ons = this.quotation.add_ons
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      if (this.quotation.total_amount > 0) {
        this.$axios.post(`/subscription/bills/${data.bill}/request_manual_payment/`, this.form)
          .then(resp => {
            const data = resp.data
            setTimeout(() => {
              location.href = data.bill_url
            }, 1000)
          })
          .catch(() => {
            this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
            this.isLoading = false
          })
      } else {
        this.$emit('subscribed')
        this.fetchCompany()
        this.isLoading = false
        this.step++
      }
    },
    retryPayment () {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    checkCurrentPlan () {
      if (this.$route.query.upgrade) {
        this.selectedCommitmentType = 1
        this.selectPlan(this.plans.find(f => f.plan.includes('GROWTH')))
      } else {
        if (this.yezzaSubscription.data.contract.billing_cycle === 'monthly') {
          this.selectedCommitmentType = 1
        }
        this.plans.forEach(plan => {
          if (this.currentPlan(plan)) {
            this.selectPlan(plan)
          }
        })
      }
      this.checkAddons()
    },
    currentPlan (plan) {
      if (this.yezzaSubscription.data.plan === plan.plan) {
        if (this.yezzaSubscription.data.contract.billing_cycle === 'yearly' && this.selectedCommitmentType === 0) {
          return true
        } else if (this.yezzaSubscription.data.contract.billing_cycle === 'monthly' && this.selectedCommitmentType === 1) {
          return true
        }
      }
      return false
    },
    checkAddons () {
      if (this.yezzaSubscription.data.add_ons && this.yezzaSubscription.data.add_ons.length > 0) {
        let formAddons = this.yezzaSubscription.data.add_ons.find(f => f.add_on.feature.code === 'YZ_FORM')
        if (formAddons) {
          this.formAddOnCount = formAddons.count
        }
        let memberAddons = this.yezzaSubscription.data.add_ons.find(f => f.add_on.feature.code === 'YZ_MEMBER')
        if (memberAddons) {
          this.memberAddOnCount = memberAddons.count
        }
      }
    },
    clickPayBill () {
      if (this.quotation.pending_bills.length > 0) {
        this.$router.push(`/admin/billing/bills/${this.quotation.pending_bills[0]}`)
      }
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.quotation.total_amount
        })
      })
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.quotation.total_amount/100,
        currency: 'MYR'
      }, {eventID: eventID})
    },
    closeDialog () {
      if (this.$route.query.upgrade) {
        if (this.$route.query.upgrade === 'followup') {
          this.$router.push('/admin/follow-up')
        } else if (this.$route.query.upgrade === 'bundle') {
          this.$router.push('/admin/offers')
        } else if (this.$route.query.upgrade === 'reseller') {
          this.$router.push('/admin/resellers')
        }
      }
      this.$emit('setgene')
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.slash-price {
  display: inline-block;
  text-decoration: none;
  position: relative;
}
.slash-price:after {
  content: '';
  display: block;
  width: 100%;
  height: 52%;
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 2px solid;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.main-container {
  position: relative;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "account_suspended": "Account Suspended",
    "card_actions": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "confirm_pay": "Confirm and pay",
      "contract": "contract",
      "forms": "forms ({text} add-ons)",
      "manage_account": "Manage your account or select add-ons to fit this plan",
      "next": "Next",
      "salespersons": "salespersons ({text} add-ons)",
      "selected_plan": "Selected plan:",
      "service_fee": "Service Fee (% of transaction)",
      "subscrbe_later": "Subscribe later"
    },
    "step_0": {
      "addons": "Add-ons",
      "active_addons": "Active add-ons",
      "boost_sales": "( Recommended to Boost your Sales )",
      "current_account": "Your current account",
      "current_plan": "Current Plan",
      "each_month": "each/month",
      "each_year": "each/year",
      "follow_up_system": "Follow-up System",
      "agent_commission_system": "Agent Commission System",
      "product_bundle_offer": "Product Bundle Offer",
      "form": "Form",
      "forms": "published forms",
      "manage_button": "Manage",
      "members": "active salespersons / agents",
      "monthly_contract": "Monthly contract",
      "monthly_offer": "Grab discount now!",
      "salesperson": "Salesperson",
      "yearly_contract": "Yearly contract",
      "yearly_offer": "2 Months Free",
      "subscribed_addons": "Subscribed add-ons",
      "form_addons": "+ {count} form (active until {date}) | + {count} forms (active until {date})",
      "member_addons": "+ {count} member (active until {date}) | + {count} members (active until {date})"
    },
    "step_1": {
      "annual_billing": "For annual billing only",
      "card": "Credit or debit card",
      "choose_bank": "Choose bank for payment",
      "online": "Online banking",
      "select_payment_method": "Select payment method",
      "yearly_contract": "For yearly contract only"
    },
    "step_2": {
      "confirm_subscribe": "Confirm your subscription",
      "extra_form": "extra form | extra forms",
      "extra_member": "extra member | extra members",
      "plan": "Plan",
      "price_month": "per month with monthly contract",
      "price_year": "per {text} with yearly contract",
      "transacton": "of transaction",
      "current_billing_amount": "Current billing amount: {amount}",
      "next_billing_amount": "Next billing amount: {amount}",
      "next_billing_date": "Next billing date: {date}",
      "pending_payment": "Pending payment",
      "pay_now": "Pay now",
      "you_have": "You have {count} pending payment. | You have {count} pending payments.",
      "please_take": "Please take care of any outstanding payments before changing subscription"
    },
    "step_3": {
      "finish_button": "FINISH",
      "subscribe_successful": "Subscription successful!",
      "thanks": "Thank you for giving us the opportunity to help you grow further and bigger.",
      "thanks_2": "Let’s do this together."
    },
    "step_4": {
      "payment_failed": "Payment failed",
      "retry_button": "Retry Payment",
      "try_again": "The payment did not go through, please try again."
    },
    "subscription": "Yezza Subscription"
  },
  "id": {
    "account_suspended": "Akun Ditangguhkan",
    "card_actions": {
      "back": "Kembali",
      "cancel": "Batal",
      "close": "Tutup",
      "confirm_pay": "Mengkonfirmasi dan membayar",
      "contract": "kontrak",
      "forms": "form (pengaya {text})",
      "manage_account": "Kelola akun kamu atau pilih add-on agar sesuai dengan paket ini",
      "next": "Lanjut",
      "salespersons": "wiraniaga (pengaya {text})",
      "selected_plan": "Paket yang dipilih:",
      "service_fee": "Biaya Layanan (% dari transaksi)",
      "subscrbe_later": "Berlangganan nanti"
    },
    "step_0": {
      "addons": "Add-on",
      "active_addons": "Add-ons aktif",
      "boost_sales": "(Disarankan untuk Meningkatkan Penjualan kamu)",
      "current_account": "Akun kamu saat ini",
      "current_plan": "Rencana saat ini",
      "each_month": "setiap bulan",
      "each_year": "setiap tahun",
      "follow_up_system": "Sistem tindak lanjut",
      "agent_commission_system": "Sistem Komisi Agen",
      "product_bundle_offer": "Penawaran Paket Produk",
      "form": "Form",
      "forms": "form yang diterbitkan",
      "manage_button": "Mengelola",
      "members": "penjual/agen aktif",
      "monthly_contract": "paket bulanan",
      "monthly_offer": "Dapatkan diskon sekarang!",
      "salesperson": "Salesperson",
      "yearly_contract": "Paket tahunan",
      "yearly_offer": "2 Bulan Gratis",
      "subscribed_addons": "Pengaya berlangganan",
      "form_addons": "+ {count} form (aktif sampai {date}) | + {count} forms (aktif sampai {date})",
      "member_addons": "+ {count} anggota (aktif sampai {date}) | + {count} anggota (aktif sampai {date})"
    },
    "step_1": {
      "annual_billing": "Hanya untuk tagihan tahunan",
      "card": "Kartu kredit atau debit",
      "choose_bank": "Pilih bank untuk pembayaran",
      "online": "Perbankan online",
      "select_payment_method": "Pilih metode pembayaran",
      "yearly_contract": "Hanya untuk paket tahunan"
    },
    "step_2": {
      "confirm_subscribe": "Konfirmasi langganan kamu",
      "extra_form": "form tambahan | form tambahan",
      "extra_member": "anggota tambahan | anggota tambahan",
      "plan": "Plan",
      "price_month": "per bulan dengan paket bulanan",
      "price_year": "per {text} dengan paket tahunan",
      "transacton": "transaksi",
      "next_billing_date": "Tanggal tagihan berikutnya: {date}",
      "pending_payment": "Pembayaran tertunda",
      "pay_now": "Bayar sekarang",
      "you_have": "Anda memiliki {count} pembayaran yang tertunda. | kamu memiliki {count} pembayaran yang tertunda.",
      "please_take": "Harap selesaikan pembayaran terutang sebelum mengubah langganan"
    },
    "step_3": {
      "finish_button": "SELESAI",
      "subscribe_successful": "Berlangganan berhasil!",
      "thanks": "Terima kasih telah memberi kami kesempatan untuk membantu kamu tumbuh lebih jauh dan lebih besar.",
      "thanks_2": "Mari kita lakukan ini bersama."
    },
    "step_4": {
      "payment_failed": "Pembayaran gagal",
      "retry_button": "Coba lagi Pembayaran",
      "try_again": "Pembayaran tidak berhasil, harap coba lagi."
    },
    "subscription": "Berlangganan Yezza"
  }
}
</i18n>
